import {
  isEligibleForFreeTrial,
  isUserPremium,
} from 'app/features/user/selectors';
import {
  ALREADY_PREMIUM_PATH,
  BILLING_PATH,
  INVALID_COUPON_PATH,
  OFFER_INELIGIBLE_PATH,
  UNAVAILABLE_PATH,
} from 'app/router/constants/paths';
import { freeTrialUrl } from 'app/features/checkout/selectors';
import {
  getSelectedSku,
  isSkipFreeTrial,
} from 'app/features/products/selectors';
import { PRODUCT_COMPARISON_ANCHOR } from 'app/features/landing/productComparison/constants';
import { localRedirect } from 'app/router/actions';
import {
  isSelectedCouponInValid,
  selectedCoupon,
} from 'app/features/couponCampaign/selectors';
import { getParsedNextParam, getSearch } from 'app/router/selectors';
import { isMigrationCouponFlow } from 'app/features/migration/landing/selectors';

function toFreeTrialCheckout(state) {
  window.location.assign(
    freeTrialUrl(state, {
      sku: getSelectedSku(state),
    }),
  );
}

const migrationCouponFlowRedirects = (state, dispatch) => {
  if (isSelectedCouponInValid(state)) {
    return dispatch(
      localRedirect(`${UNAVAILABLE_PATH}?nextlevel=invalidcoupon`),
    );
  }

  return toFreeTrialCheckout(state);
};

const couponFlowRedirects = () => (dispatch, getState) => {
  const state = getState();

  if (isMigrationCouponFlow(state)) {
    return migrationCouponFlowRedirects(state, dispatch);
  }

  if (isSelectedCouponInValid(state)) {
    return window.location.assign(INVALID_COUPON_PATH);
  }

  if (isEligibleForFreeTrial(state)) {
    return toFreeTrialCheckout(state);
  }

  return window.location.assign(OFFER_INELIGIBLE_PATH);
};

function onAuthenticationRedirect() {
  return (dispatch, getState) => {
    const state = getState();
    const isPremium = isUserPremium(state);
    const selectedSku = getSelectedSku(state);
    const nextParam = getParsedNextParam(state);

    if (isPremium) return dispatch(localRedirect(ALREADY_PREMIUM_PATH));

    if (!selectedSku) {
      const productsAnchor = getSearch(state) + PRODUCT_COMPARISON_ANCHOR;

      return dispatch(localRedirect(nextParam || productsAnchor));
    }

    if (selectedCoupon(state)) {
      return dispatch(couponFlowRedirects());
    }

    if (isEligibleForFreeTrial(state) && !isSkipFreeTrial(state)) {
      return toFreeTrialCheckout(state);
    }

    return dispatch(localRedirect(BILLING_PATH, { fromLogin: true }));
  };
}

export { onAuthenticationRedirect, couponFlowRedirects };
